import axios from "axios";

const formsApiUrl = process.env.REACT_APP_FORMS_API_URL;
const formsAccessToken = process.env.REACT_APP_FORMS_ACCESS_TOKEN;

const normalizeValue = (value) => {
    if (Array.isArray(value)) {
        return value.filter(Boolean).join(", ");
    }

    return value ?? "";
};

const buildFields = (formData) => ({
    name: normalizeValue(formData.name),
    email: normalizeValue(formData.email),
    interest: normalizeValue(formData.interest),
    budget: normalizeValue(formData.budget),
    message: normalizeValue(formData.message),
    referral: normalizeValue(formData.referral),
});

const buildMetadata = () => ({
    referrer: document.referrer || "",
    userAgent: navigator.userAgent || "",
    language: navigator.language || "",
});

export const sendForm = (formData, onSuccess, onError) => {
    if (!formsApiUrl || !formsAccessToken) {
        const error = new Error("Forms API environment variables are not configured");
        onError && onError(error);
        return;
    }

    const payload = {
        fields: buildFields(formData),
        pageUrl: 'https://qclay.design',
        metadata: buildMetadata(),
        companyWebsite: formData.companyWebsite || "",
    };

    axios
        .post(formsApiUrl, payload, {
            headers: {
                Authorization: `Bearer ${formsAccessToken}`,
                "Content-Type": "application/json",
            },
        })
        .then(function (response) {
            onSuccess && onSuccess(response);
        })
        .catch(function (error) {
            onError && onError(error);
        });
};
